import React from 'react';
import './PartnerGallery.css';

const partners = [
  {
    name: 'Peter Quizon',
    description: `Over 20 years of experience with a Big 4 Public Accounting Firm\nHas experience working with various companies on accounting and financial reporting`,
    reviews: 'Reviews',
    linkedTo: [
      'Administrative support',
      'Book keeping',
      'Financial Reporting',
      'Business process support',
      'Budget preparation and support',
    ],
    image: null,
  },
  {
    name: 'Ruth Maza',
    description: '',
    reviews: 'Reviews',
    linkedTo: [
      'Administrative support',
      'Book keeping',
      'Financial Reporting',
      'Business process support',
      'Budget preparation and support',
    ],
    image: null,
  },
];

export default function PartnerGallery() {
  return (
    <div className="partner-gallery">
      {partners.map((partner, idx) => (
        <div className="partner-card" key={idx}>
          <div className="partner-image-placeholder">
            {/* Placeholder for profile image */}
            {partner.image ? (
              <img src={partner.image} alt={partner.name + ' profile'} className="partner-image" />
            ) : (
              <div className="partner-image initials">
                {partner.name.split(' ').map(n => n[0]).join('').substring(0,2)}
              </div>
            )}
          </div>
          <div className="partner-header">
            <div className="partner-name">{partner.name}</div>
          </div>
          <div className="partner-description">{partner.description}</div>
          <div className="partner-linked">
            <span className="linked-label">Linked to:</span>
            <ul>
              {partner.linkedTo.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="partner-reviews">{partner.reviews}</div>
        </div>
      ))}
    </div>
  );
}
